import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  schools: [],
};

export const createSchool = createAsyncThunk(
  "createSchool/school",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("schools", data);
      enqueueSnackbar("School is added successfully");
      navigate(PATH_DASHBOARD.entries.schools.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchSchools = createAsyncThunk(
  "fetchSchools/school",
  async ({ enqueueSnackbar, limit = 8, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(
        `schools?limit=${limit}&page=${page + 1}`
      );

      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateSchools = createAsyncThunk(
  "updateSchools/school",
  async ({ slug, data, enqueueSnackbar, setOpenEdit }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`schools/${slug}`, data);

      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteSchool = createAsyncThunk(
  "deleteSchool/school",
  async ({ id, enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      await axiosInstance.delete(`schools/${id}`);
      thunkApi.dispatch(fetchSchools({ limit, page }));
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const schoolSlice = createSlice({
  name: "school",
  initialState,
  extraReducers: (builder) => {
    // TODO: create school
    builder.addCase(createSchool.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createSchool.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createSchool.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch school
    builder.addCase(fetchSchools.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSchools.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.schools = action.payload;
    });

    builder.addCase(fetchSchools.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update school
    builder.addCase(updateSchools.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateSchools.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("School is updated successfully");
      state.schools.data = state.schools.data.map((school) =>
        school.slug === action.payload.slug ? action.payload.data : school
      );
      action.payload.setOpenEdit(false);
    });

    builder.addCase(updateSchools.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete school
    builder.addCase(deleteSchool.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteSchool.fulfilled, (state, action) => {
      state.isLoading = false;
      // state.schools.data = state.schools.data.filter(
      //   (school) => school.id !== action.payload.id
      // );
      action.payload.enqueueSnackbar("School is deleted successfully");
    });

    builder.addCase(deleteSchool.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default schoolSlice.reducer;
